export interface DevicesInfo {
    sensorCaptions: KeyValueStringPair[];
    groups: DevicesGroup[];
}

export interface KeyValueStringPair {
    key: number;
    value: string;
}

export interface DevicesGroup {
    name: string;
    devices: DeviceInfo[];
}

export interface DeviceInfo {
    name: string;
    protocol: string;
    sensors: SensorInfo[];
}

export type SensorInfo = KeyValueStringPair[];

export enum SensorInfoItemType {
    sysName = 0,
    name = 1,
    optional = 2,
    formula = 3,
    filter = 4,
}
